import styled from '@emotion/styled';
import {Box, Dialog, DialogContent, FormControl} from '@mui/material';

import theme from 'config/theme';

export const StyledAddressFormDialogContent = styled(DialogContent)<{updatePadding?: boolean}>(({updatePadding}) => ({
  padding: updatePadding ? 0 : undefined,
  overflow: updatePadding ? 'hidden' : undefined
}));

export const StyledAddressFormDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    height: '100%'
  }
}));

export const StyledTitleContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
})) as typeof Box;

export const StyledFormControl = styled(FormControl)({
  '& label.MuiFormLabel-root, & label.MuiFormLabel-colorPrimary': {
    color: theme.palette.grey[400],
    '&.Mui-disabled': {
      color: theme.palette.grey[300]
    },
    '&.Mui-error': {
      color: theme.palette.error.main
    }
  },
  '& .MuiFilledInput-root': {
    border: `1px solid ${theme.palette.grey[200]}`,
    overflow: 'hidden',
    borderRadius: 4,
    backgroundColor: `${theme.palette.common.white} !important`,
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    '&:before, &:after': {
      display: 'none !important'
    },
    '&:hover': {
      backgroundColor: theme.palette.common.white
    },
    '&.Mui-focused, &:hover': {
      borderColor: theme.palette.secondary.main
    },
    '& input': {
      '&::placeholder': {
        color: 'transparent'
      }
    },
    '&.Mui-focused': {
      outline: `${theme.palette.secondary.main} solid 1px`,
      '& input': {
        '&::placeholder': {
          color: 'inherit'
        }
      },
      '&.Mui-error': {
        outline: `${theme.palette.error.main} solid 1px`
      }
    },
    '&.Mui-disabled': {
      backgroundColor: `${theme.palette.grey[50]} !important`,
      '& input.Mui-disabled': {
        textFillColor: theme.palette.grey[400]
      }
    },
    '&.Mui-error': {
      borderColor: theme.palette.error.main
    }
  }
});
